import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ChatCircleText } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export const InboxButton = () => {
  const { user } = useAuth();
  const [summary, setSummary] = useState(null);
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/inbox/summary").then(r => alive && setSummary(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, [loc.pathname]);

  if (user?.role === "public_student") return null;
  if (!summary || !summary.inbox_enabled) return null;
  const unread = summary.unread_threads || 0;

  return (
    <button data-testid="inbox-button"
      className="relative flex items-center px-2.5 py-1.5 rounded-full bg-white border border-[#C4C8CE] hover:bg-[#F4F4F5] transition-colors cursor-pointer"
      title="Inbox" onClick={() => nav("/inbox")}>
      <ChatCircleText size={18} weight="duotone" color="#0A0D14" />
      {unread > 0 && (
        <span data-testid="inbox-unread-badge" className="absolute -top-1 -right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#FF5100] text-white text-[10px] font-bold flex items-center justify-center">
          {unread > 9 ? "9+" : unread}
        </span>
      )}
    </button>
  );
};
